export const EuroNCAPFlag = ({ styles }: { styles?: React.CSSProperties }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="500"
    height="252.92"
    version="1"
    viewBox="0 0 500 252"
    style={{ ...styles, maxWidth: '100px' }}
  >
    <g id="layer1" transform="translate(-1155.286 -519.804)">
      <g id="g2508" fillOpacity="1" transform="translate(826.715 542.128)scale(.29306)">
        <path
          id="path2464"
          fill="#343a3a"
          d="M1957.786 594.65c-113.363-10.688-203.795-94.726-222.967-207.2-11.36-66.648 6.767-138.096 48.775-192.246 70.274-90.59 191.835-121.007 297.692-74.491 33.47 14.707 67.429 40.936 91.288 70.506 38.912 48.229 58.974 111.031 54.731 171.337-2.445 34.753-9.96 62.96-24.964 93.697-13.235 27.114-27.906 47.283-50.187 68.992-32.16 31.336-68.919 51.83-113.022 63.014-23.125 5.864-57.932 8.599-81.346 6.391"
        />
        <path
          id="path2462"
          fill="#f9ea4f"
          d="M1971.286 466.72v-111h-222.3l.639 9.762c.352 5.369 1.365 14.031 2.251 19.25 16.821 99.038 94.884 176.006 193.674 190.958 6.73 1.019 15.273 1.892 18.986 1.94l6.75.09z"
        />
        <path
          id="path2460"
          fill="#f9ea4f"
          d="M2017.298 575.129c39.376-6.688 76.737-23.51 107.663-48.476 12.224-9.868 29.016-27.347 38.874-40.461 24.722-32.892 39.524-69.401 44.914-110.774.845-6.49 1.537-13.578 1.537-15.75v-3.949h-80.962l-.429 2.25c-5.163 27.097-9.097 40.419-16.735 56.673-17.962 38.224-48.787 64.526-87.37 74.55-8.471 2.202-17.141 3.63-30.754 5.065l-5.75.606v83.157l9.762-.64c5.37-.352 14.032-1.365 19.25-2.251"
        />
        <path
          id="path2458"
          fill="#f9ea4f"
          d="M1830.8 334.97c3.457-21.458 8.442-38.034 16.578-55.127 7.621-16.01 15.038-27.056 25.673-38.231 11.293-11.867 22.08-19.783 36.735-26.954 16.676-8.16 32.316-12.288 54.75-14.448l6.75-.65V116.42l-9.763.64c-50.604 3.316-102.086 26.285-140.592 62.727-41.02 38.823-67.737 94.712-71.306 149.171l-.64 9.762h81.21z"
        />
        <path
          id="path2456"
          fill="#f9ea4f"
          d="M2210.286 334.77c0-6.6-2.925-26.88-5.61-38.899-16.166-72.371-69.34-134.956-138.098-162.542-22.055-8.848-47.45-14.89-68.353-16.259l-9.94-.651v222.3h222z"
        />
        <path
          id="path2454"
          fill="#343a3a"
          d="M1329.919 478.695c-20.224-2.318-33.147-9.84-38.78-22.573-4.508-10.193-4.818-14.806-4.836-72.153l-.017-54.25h21l.007 47.75c.005 26.263.447 51.565.983 56.228 2.41 20.968 11.944 26.76 42.533 25.842 11.774-.353 14.765-.775 18.977-2.673 6.507-2.933 9.822-6.206 12.677-12.514l2.323-5.133.29-54.75.29-54.75h21.01l-.316 58.25c-.308 56.95-.363 58.378-2.485 63.983-7.249 19.151-20.82 26.181-52.532 27.213-7.292.237-16.797.026-21.124-.47"
        />
        <path
          id="path2452"
          fill="#343a3a"
          strokeWidth="0.293"
          d="M151.1 118.178c-3.196.001-6.387.191-7.756.566-6.331 1.734-9.477 5.02-11.162 11.666-.493 1.943-.657 3.674-.774 8.207-.17 6.632.144 9.68 1.397 13.576 2.05 6.378 6.13 9.467 13.761 10.412 2.925.363 8.782.14 11.627-.44 6.446-1.317 10.079-4.904 11.807-11.661.908-3.552 1.295-9.395.928-14.018-.858-10.786-4.132-15.609-12.053-17.75-1.383-.373-4.58-.56-7.775-.558m.01 5.61c6.221 0 7.605.278 9.617 1.937 2.397 1.976 3.367 5.305 3.62 12.423.43 12.069-1.494 17.001-7.214 18.485-.747.194-2.738.422-4.424.506-8.559.425-12.182-1.421-13.836-7.05-.841-2.862-1.079-13.653-.389-17.63.622-3.58 1.842-5.952 3.653-7.1 2.276-1.443 3.002-1.572 8.972-1.572"
          transform="matrix(3.41224 0 0 3.41224 1121.163 -76.175)"
        />
        <path
          id="path2448"
          fill="#343a3a"
          d="M2455.286 478.594c-22.022-2.543-36.229-11.37-44.055-27.375-7.477-15.29-10.6-41.941-7.911-67.5 2.665-25.332 10.952-41.283 25.554-49.192 2.735-1.481 8.558-3.731 12.942-5 7.211-2.088 9.921-2.302 28.47-2.247 17.008.051 22.179.425 30.359 2.193 5.422 1.172 10.062 2.334 10.31 2.581.247.248-.645 4.436-1.982 9.308-1.618 5.892-2.893 8.815-3.81 8.73-.757-.07-4.977-.928-9.377-1.907-11.251-2.503-37.555-2.556-46-.092-16.683 4.867-22.618 16.228-24.095 46.126-1.174 23.782 2.235 43.94 8.914 52.697 6.67 8.744 14.197 11.667 32.18 12.499 11.776.544 30.875-1.367 37.024-3.704 2.322-.883 2.516-.654 4.033 4.79.877 3.145 2.059 7.222 2.627 9.06.573 1.856.651 3.712.175 4.173-2.25 2.177-31.343 6.152-42.858 5.855-2.75-.071-8.375-.519-12.5-.995"
        />
        <path
          id="path2446"
          fill="#343a3a"
          d="M1155.286 403.22v-73.5h103v19h-82v41h58v18h-58v50h82v19h-103z"
        />
        <path
          id="path2444"
          fill="#343a3a"
          strokeWidth="0.293"
          d="m92.203 119.1-.074 21.466-.076 21.467h6.451V144.45h3.906c3.887 0 3.914.004 5.293.917 2.521 1.67 6.22 6.407 10.188 13.049l2.154 3.61 3.906.003 3.908.004-.662-1.1c-5.447-9.057-10.333-15.593-12.806-17.126l-1.086-.672 1.838-.229q9.097-1.13 9.664-10.537c.395-6.565-2.122-11.058-7.067-12.613-2.02-.636-2.484-.656-13.814-.656zm6.3 5.091 7.548.092c8.749.106 9.211.223 10.758 2.713.761 1.227.881 1.725.986 4.115.18 4.097-.822 6.384-3.285 7.502-1.075.488-2.013.55-8.606.555l-7.4.006v-14.982"
          transform="matrix(3.41224 0 0 3.41224 1121.163 -76.175)"
        />
        <path
          id="path2440"
          fill="#343a3a"
          d="m2260.53 403.47.256-73.25 14.064-.277 14.065-.276 9.39 14.776c12.646 19.895 35.138 57.7 47.98 80.641l10.5 18.757.259-57.06.258-57.062h20.984v147l-12.75-.02-12.75-.019-12-21.693c-12.11-21.891-45.008-77.404-54.088-91.268l-4.912-7.5-.258 60.25-.258 60.25h-20.997z"
        />
        <path
          id="path2438"
          fill="#343a3a"
          strokeWidth="0.293"
          d="m425.8 119.1-1.01 2.49c-1.955 4.818-6.228 16.045-8.726 22.922-2.202 6.064-6.035 17.124-6.035 17.418 0 .056 1.428.103 3.172.103h3.172l1.91-5.935 1.91-5.934 9.985-.078 9.984-.076.8 2.129c.442 1.17 1.484 3.842 2.315 5.937l1.512 3.81 3.428.083c1.885.045 3.428-.002 3.428-.104s-1.047-2.783-2.327-5.959c-3.779-9.38-7.8-20.37-11.966-32.705l-1.385-4.101H425.8m3.954 5.127h.982c.659 0 .98.138.98.421 0 .232 1.45 4.773 3.223 10.09s3.225 9.744 3.225 9.836c0 .214-15.673.224-15.887.01-.167-.167 2.95-8.81 5.793-16.063z"
          transform="matrix(3.41224 0 0 3.41224 1121.163 -76.175)"
        />
        <path
          id="path2434"
          fill="#343a3a"
          strokeWidth="0.293"
          d="M457.213 118.953v43.08h6.154v-14.947l7.84-.004c10.547-.007 12.696-.493 15.397-3.482 2.07-2.293 3.075-5.006 3.34-9.03.432-6.582-1.628-11.885-5.417-13.945-2.74-1.49-4.424-1.662-16.398-1.668zm17.5 5.322c1.418.017 2.507.054 2.926.104 2.016.24 3.27 1.13 4.332 3.08.793 1.459.881 1.906.984 4.945.163 4.822-.753 7.292-3.164 8.522-1.076.549-1.715.592-8.797.592h-7.635l.077-8.573.078-8.57 6.3-.09c1.733-.024 3.48-.026 4.899-.01"
          transform="matrix(3.41224 0 0 3.41224 1121.163 -76.175)"
        />
      </g>
    </g>
  </svg>
);
